import {createContext} from 'react'

export const PendingContext = createContext(false)